<template>
  <div class="air_ListBox">
    <div class="search-form">
      <el-row type="flex" :gutter="20" align="middle" v-if="navType==1">
        <el-col class="el-col-label flex-center-start" :span="10">
          <span>下单日期:</span>
          <el-date-picker
            v-model="searchForm.OrdersDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-col>
        <el-col class="el-col-label flex-center-start" :span="10">
          <span>出票日期:</span>
          <el-date-picker
            v-model="searchForm.ticketDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-col>
      </el-row>
      <el-row
        type="flex"
        :gutter="20"
        align="middle"
        v-if="navType==2||navType==3||navType==4||navType==5"
      >
        <el-col class="el-col-label flex-center-start">
          <span>申请日期:</span>
          <el-date-picker
            v-model="searchForm.applyDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-col>
        <el-col class="el-col-label" v-show="navType==2">
          <span>改签单号:</span>
          <input clearable v-model="searchForm.changeNo" @keyup.13="search">
        </el-col>
        <el-col class="el-col-label" v-show="navType==3">
          <span>退票单号:</span>
          <input clearable v-model="searchForm.refundNo" @keyup.13="search">
        </el-col>
        <el-col class="el-col-label" v-show="navType==3||navType==4">
          <span>退款流水号:</span>
          <input clearable v-model="searchForm.refundTradeNo" @keyup.13="search">
        </el-col>
        <el-col class="el-col-label" v-show="navType==4">
          <span>废票单号:</span>
          <input clearable v-model="searchForm.productName" @keyup.13="search">
        </el-col>
        <el-col class="el-col-label" v-show="navType==5">
          <span>行程订单号:</span>
          <input clearable v-model="searchForm.itineraryNo" @keyup.13="search">
        </el-col>
        <el-col class="el-col-label input-style" v-show="navType==5">
          <span>订单状态:</span>
          <el-select v-model="searchForm.serviceStatus" placeholder="">
            <el-option
              v-for="item in regionalTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex" align="middle" style="margin-top:10px;">
        <el-col :span="10" class="el-col-label">
          <span>票号:</span>
          <input clearable v-model="searchForm.ticketNumber" @keyup.13="search">
        </el-col>
        <el-col class="el-col-label" :span="10">
          <span>交付流水号:</span>
          <input clearable v-model="searchForm.payTradeNo" @keyup.13="search">
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex" align="middle" style="margin-top:10px;" v-show="navType!=5">
        <el-col :span="10" class="el-col-label">
          <span>订单号:</span>
          <input clearable v-model="searchForm.orderNo" @keyup.13="search">
        </el-col>
        <el-col class="el-col-label input-style" :span="10">
          <span>订单状态:</span>
          <el-select v-model="searchForm.serviceStatus" placeholder="">
            <el-option
              v-for="item in regionalTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <div class="btn_box">
        <el-button type="primary" @click="search" size="small">搜索</el-button>
        <el-button @click="reset" size="small">重置</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span="24">
        <div class="table-nav">
          <div
            class="nav-item cursor"
            v-for="(item,index) in changeRecordList"
            :key="index"
            :class="{'nav-item-active':NavItemActive==index}"
            @click="statuSearch(item,index)"
          >{{item.text}}</div>
          <div class="table-nav-btn">
            <el-button size="small" type="success" @click="_exportExcel">导出报表</el-button>
          </div>
        </div>
        <drawBill v-if="navType===1" :pageData="pageData" @getItem="getItem"/>
        <refundBill v-if="navType===3" :pageData="pageData" @getItem="getItem"/>
        <changBill v-if="navType===2" :pageData="pageData" @getItem="getItem"/>
        <invalidatedBill v-if="navType===4" :pageData="pageData" @getItem="getItem"/>
        <restBill v-if="navType===5" :pageData="pageData" @getItem="getItem"/>
        <div style="margin-bottom: 10px;"></div>
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          background=""
          @size-change="handlerSize"
          @current-change="handlerPage"
          :current-page="searchForm.currentPage"
          :page-sizes="[10,20,30,40,50]"
          :page-size="10"
          :page-count="searchForm.pageSize"
          :total="totalCount"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import restBill from "./table/restBill";
import changBill from "./table/changBill";
import drawBill from "./table/drawBill";
import refundBill from "./table/refundBill";
import invalidatedBill from "./table/invalidatedBill";
import detailList from "@/lib/data-service/flight/flight_order_report_list";
import exportExcel from "@/lib/data-service/flight/exportExcel";

export default {
  data() {
    return {
      searchForm: {
        currentPage: 1,
        pageSize: 10,
        flightType: 1, // 1 国内 2 国际
        ticketDate: [],
        applyDate: [],
        OrdersDate: [],
        serviceStatus: ""
      },
      pageData: [],
      NavItemActive: 0,
      regionalTypeList: [],
      loading: false,
      totalCount: 0,
      navType: 1, // 1 出票 3 退票 2 改签 4 废票 5 其他
      selectList: [],
      excelForm: {}
    };
  },
  components: {
    invalidatedBill,
    refundBill,
    drawBill,
    changBill,
    restBill
  },
  props: {
    changeRecordList: {
      type: Array,
      default: []
    },
    flightType: Number
  },
  methods: {
    search() {
      let data = this.searchForm;
      data.serviceType = this.navType;
      let timeForm = {
        applyDate: ["applyStartDate", "applyEndDate"],
        ticketDate: ["ticketStartDate", "ticketEndDate"],
        OrdersDate: ["ordersStartDate", "ordersEndDate"]
      };
      Object.keys(timeForm).map(key => {
        getTime(timeForm[key], data[key]);
      });
      function getTime(timeList, dateList) {
        if (!dateList || dateList.length == 0) {
          timeList.map((name, index) => {
            data[name] = "";
          });
          return;
        }
        timeList.map((name, index) => {
          data[name] = dateList[index];
        });
      }
      detailList(data).then(res => {
        console.log(res);
        this.pageData = res.pageResult.pageData;
        this.totalCount = res.pageResult.totalCount;
      });
    },
    getItem(val) {
      // this.selectList = val;
      this.selectList = val.map(item => {
        return item.id;
      });
    },
    reset() {
      this.searchForm = {
        currentPage: 1,
        pageSize: 10,
        flightType: this.flightType,
        serviceStatus: ""
      };
      this.search();
    },
    _exportExcel() {
      if (this.pageData.length === 0)
        return this.$message({ type: "warning", message: "空数据无法导出！" });
      let data = this.excelForm,
        selectList = this.selectList;
      // data.serviceType === 1
      //   ? (data.ticketReportExportList = selectList)
      //   : data.serviceType === 2
      //     ? (data.changeReportExportList = selectList)
      //     : data.serviceType === 3
      //       ? (data.refundReportExportList = selectList)
      //       : data.serviceType === 4
      //         ? (data.invalidateReportExportList = selectList)
      //         : (data.otherReportExportList = selectList);
      selectList.length > 0
        ? (data.ids = selectList.join(","))
        : delete data.ids;
      exportExcel(data).then(res => {
        let uInt8Array = new Uint16Array(res);
        let blob = new Blob([uInt8Array], { type: "application/vnd.ms-excel" });
        let blobURL = window.URL.createObjectURL(blob);
        let tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", data.sheetName);
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
      });
    },
    statuSearch(item, index) {
      this.NavItemActive = index;
      this.navType = item.value;
      this.searchForm.currentPage = 1;
      this.selectList.length = 0;
      this.searchForm.serviceStatus = "";
      item.value === 1
        ? (this.regionalTypeList = [
            { value: "", label: "全部" },
            { value: 21, label: "待出票" },
            { value: 22, label: "出票成功" },
            { value: 23, label: "出票失败" }
          ])
        : item.value === 2
          ? (this.regionalTypeList = [
              { value: "", label: "全部" },
              { value: 31, label: "处理中" },
              { value: 35, label: "改签成功" },
              { value: 36, label: "改签失败" },
              { value: 34, label: "已补款" },
              { value: 37, label: "已取消" }
            ])
          : item.value === 3
            ? (this.regionalTypeList = [
                { value: "", label: "全部" },
                { value: 41, label: "申请中" },
                { value: 44, label: "处理中" },
                { value: 45, label: "退票成功" },
                { value: 46, label: "退票失败" },
                { value: 47, label: "已取消" }
              ])
            : item.value === 4
              ? (this.regionalTypeList = [
                  { value: "", label: "全部" },
                  { value: 1, label: "处理中" },
                  { value: 2, label: "废票成功" },
                  { value: 3, label: "废票失败" }
                ])
              : (this.regionalTypeList = [
                  { value: "", label: "全部" },
                  { value: 0, label: "待处理" },
                  { value: 1, label: "已处理" }
                ]);
      let data = {
        title: item.text,
        serviceType: item.value,
        fileName: this.flightType === 1 ? "国内对账" : "国际对账",
        sheetName: this.flightType === 1 ? "国内对账" : "国际对账",
        flightType: this.flightType
      };
      this.excelForm = data;
      this.search();
    },
    handlerSize(val) {
      this.searchForm.pageSize = val;
      this.search();
    },
    handlerPage(val) {
      this.searchForm.currentPage = val;
      this.search();
    }
  },
  activated() {
    this.searchForm.flightType = this.flightType;
    this.searchForm.OrdersDate = [
      this.$moment()
        .subtract(3, "months")
        .format("YYYY-MM-DD"),
      this.$moment().format("YYYY-MM-DD")
    ];
    this.statuSearch(this.changeRecordList[0], 0);
  }
};
</script>

<style lang='less' scoped>
@import "./css/index";
</style>
